// extracted by mini-css-extract-plugin
export default {"wrapper":"footer_wrapper__AaC8E","header":"footer_header__en8ii","sns":"footer_sns__l97hz","desc":"footer_desc__wa9xr"};